const photoCollections = [
    
    // {
    //     name: 'laser-system',
    //     primaryPic: 'facility2.jpg',
    //     title: 'Ultra-fast Laser System',
    // },
    {
        name: 'laser',
        primaryPic: 'https://sites.gsu.edu/slei/files/2020/10/873368469848972638.jpg',
        title: 'Ultra-fast Laser System',
    },
    // {
    //     name: 'laser2',
    //     primaryPic: 'laser.jpg',
    //     title: 'Ultra-fast Laser System',
    // },
    {
        name: 'zhenkong',
        primaryPic: 'facility1.jpg',
        title: '?',
    },
    // {
    //     name: 'vacuum-system',
    //     primaryPic: 'facility1.jpg',
    //     title: 'High Vacuum In-situ Growth and Characterization System',
    // },
];

export default photoCollections;